// 📁 src/Home.js
import React from "react";
import HomeIN from "./HomeIN";
import HomeGlobal from "./HomeGlobal";
import { getDomainVariant } from "./utils/domain";

export default function Home() {
  const variant = getDomainVariant();
  return variant === "IN" ? <HomeIN /> : <HomeGlobal />;
}
